import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

import { Head } from '../utils/Head';
import { Listar } from './Listar';


import '../assets/css/maestro.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


function App() {


  return (
    <>
    <Head title={'Mi casita'} description='Camara exterior de mi casita' />
    <HashRouter>
    <Routes>
      <Route path='/' element={<Listar />} />
      <Route path='*' element={<p>No encontrado - Err. 404</p>} />
    </Routes>
    </HashRouter>
    </>
  );

}



export { App };

